import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { AppStateService } from 'src/app/core-module/services/app-state.service';
import { DimmingInterfaceStateService } from "../../../core-module/services/state/dimming-interface-state.service";

@Component({
  standalone: false,
  selector: 'app-multi-config-mode',
  templateUrl: './multi-config-mode.component.html',
  styleUrls: ['./multi-config-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiConfigModeComponent extends FieldType
implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  selectedConfig = {ConfigurationMode: ""};
  allConfigs = [];
  constructor(
    
    private ref: ChangeDetectorRef,
    private appState: AppStateService,
    private dimmingInterfaceSvc: DimmingInterfaceStateService
  ) {
    super();
  }

  ngOnInit() {
    this.subscriptions.push(this.dimmingInterfaceSvc.multiconfigDefault.subscribe(res => {
      if(res){
        this.restoreDefault();
      }
    }));
    this.properties = this.field.properties;
    this.allConfigs = this.properties.ConfigurationMode["enum"];
    this.setInitialValue();
  }

  setInitialValue(){
    const data = this.appState.getConfigurationData();
    const value = "";
    if(data['resp'] && (data['resp']['multiConfigMode'] || data['resp']['MultiConfigMode'])){
      const configData = data['resp']['multiConfigMode'] ? data['resp']['multiConfigMode'] : data['resp']['MultiConfigMode'];
      this.onChangeList(configData.ConfigurationMode);
    }else{
      this.restoreDefault();
    }
  }

  onChangeList(value) {
    this.selectedConfig['ConfigurationMode'] = value;
    this.checkDefault();
    this.dimmingInterfaceSvc.sendMultiConfigData(this.selectedConfig);
    this.setConfigurationData(this.selectedConfig, 'multiConfigMode');
  }

  checkDefault(){
    if(this.properties.ConfigurationMode['default'] == this.selectedConfig.ConfigurationMode){
      this.dimmingInterfaceSvc.restoreMulticonfigDefault(true);
    }else{
      this.dimmingInterfaceSvc.restoreMulticonfigDefault(false);
    }
  }

  restoreDefault(){
    this.selectedConfig['ConfigurationMode'] = this.properties.ConfigurationMode['default'];
    this.dimmingInterfaceSvc.sendMultiConfigData(this.selectedConfig);
    this.setConfigurationData(this.selectedConfig, 'multiConfigMode');
    this.ref.markForCheck();
  }

  setConfigurationData(value, keyVal) {
    if(value != null){
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const configObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, configObj);
    }
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => {
      if(sub) sub.unsubscribe();
    })
  }
}

